import { FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { DepositTable } from './DepositTable'

export const ModalPayments = ({useFetchInit}) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,

    defaultData,
    
    //------------- Actions
    Actions
} = useFetchInit

const {FormRequestGlobal:{formState, onInputChange}} = Forms

  return (
    // <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} >
    //   <Grid item xs={12} sm={12} md={12} lg={12}>
    //     <Typography variant='subtitle2'>
    //       <strong>Informacion de la Cuota</strong> 
    //     </Typography>
    //     <div className="border-bottom border-dark"></div>
    //   </Grid>

    //   <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt: 2}}>
    //     <FormControl fullWidth> 
    //       <label htmlFor="cuota_pagar">Cuota del Mes</label>
    //       <TextField
    //           id='cuota_pagar'
    //           name='cuota_pagar'
    //           value={ formState.cuota_pagar }
    //           onChange={ onInputChange }
    //           size='small'
    //           placeholder='Cuota a Pagar'
    //           hiddenLabel
    //           type='number'
    //           variant={ 'filled'}
    //           InputProps={{
    //               readOnly: true 
    //           }}
    //       />
    //     </FormControl>
    //   </Grid>

    //   <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt: 2}}>
    //     <FormControl fullWidth> 
    //       <label htmlFor="saldo_cuota_anterior">Saldo Anterior</label>
    //       <TextField
    //           id='saldo_cuota_anterior'
    //           name='saldo_cuota_anterior'
    //           value={ formState.saldo_cuota_anterior }
    //           onChange={ onInputChange }
    //           size='small'
    //           placeholder='Cuota a Pagar'
    //           hiddenLabel
    //           type='number'
    //           variant={ 'filled'}
    //           InputProps={{
    //               readOnly: true 
    //           }}
    //       />
    //     </FormControl>
    //   </Grid>

    //   <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt: 2}}>
    //     <FormControl fullWidth> 
    //       <label htmlFor="mora">Mora</label>
    //       <TextField
    //           id='mora'
    //           name='mora'
    //           value={ formState.mora }
    //           onChange={ onInputChange }
    //           size='small'
    //           placeholder='Mora'
    //           hiddenLabel
    //           type='number'
    //           variant={ 'filled'}
    //           InputProps={{
    //               readOnly: true 
    //           }}
    //       />
    //     </FormControl>
    //   </Grid>

    //   <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt: 2}}>
    //     <FormControl fullWidth> 
    //       <label htmlFor="total_pagar">Total a Pagar</label>
    //       <TextField
    //           id='total_pagar'
    //           name='total_pagar'
    //           value={ formState.total_pagar }
    //           onChange={ onInputChange }
    //           size='small'
    //           placeholder='Total a Pagar'
    //           hiddenLabel
    //           type='number'
    //           variant={ 'filled'}
    //           InputProps={{
    //               readOnly: true 
    //           }}
    //       />
    //     </FormControl>
    //   </Grid>

    //   <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt: 2}}>
    //     <FormControl fullWidth> 
    //       <label htmlFor="total_abonado">Total Abonado</label>
    //       <TextField
    //           id='total_abonado'
    //           name='total_abonado'
    //           value={ formState.total_abonado }
    //           onChange={ onInputChange }
    //           size='small'
    //           placeholder='Total Abonado'
    //           hiddenLabel
    //           type='number'
    //           variant={ 'filled'}
    //           InputProps={{
    //               readOnly: true 
    //           }}
    //       />
    //     </FormControl>
    //   </Grid>


    //   <Grid item xs={12} sm={12} md={4} lg={4} sx={{mt: 2}}>
    //     <FormControl fullWidth> 
    //       <label htmlFor="total_restante"><strong>Total Restante</strong></label>
    //       <TextField
    //           id='total_restante'
    //           name='total_restante'
    //           value={ formState.total_restante }
    //           onChange={ onInputChange }
    //           size='small'
    //           placeholder='Total Restante'
    //           hiddenLabel
    //           type='number'
    //           variant={ 'filled'}
    //           InputProps={{
    //               readOnly: true 
    //           }}
    //       />
    //     </FormControl>
    //   </Grid>
    
    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} >
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 5}}>
        <Typography variant='subtitle2'>
          <strong>Tabla de depositos</strong>
        </Typography>
        <div className="border-bottom border-dark"></div>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{mt: 2}}>
        <DepositTable useFetchInit={useFetchInit}/>
      </Grid>
    </Grid>

  )
}
